import { useMemo } from 'react';
import type { TracePreviewBaseDto } from '@terra/shared-contracts-trace';
import { mergeSignalRelatedTraces } from '@terra/ui-design-system';
import { useTracesBySignalId } from './useTracesBySignalId';

const EMPTY_TRACES: TracePreviewBaseDto[] = [];

export function useSignalRelatedTraces({
  signalId,
  generationTraces,
  enabled = true,
}: {
  signalId: string | undefined;
  generationTraces: TracePreviewBaseDto[] | undefined;
  enabled?: boolean;
}) {
  const {
    data: linkedTraces = EMPTY_TRACES,
    isLoading,
    refetch,
  } = useTracesBySignalId({ signalId, enabled });
  const relatedTraces = useMemo(
    () =>
      mergeSignalRelatedTraces({
        traces: linkedTraces,
        generationTraces,
      }),
    [linkedTraces, generationTraces],
  );

  return { linkedTraces, relatedTraces, isLoading, refetch };
}
